var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10a2 2 0 100 4 2 2 0 000-4z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.618 9.818a1.2 1.2 0 00-.24-1.323l-.043-.044a1.455 1.455 0 112.058-2.058l.043.043a1.2 1.2 0 001.324.24 1.2 1.2 0 00.727-1.098v-.123a1.454 1.454 0 112.91 0v.065a1.2 1.2 0 00.785 1.098 1.2 1.2 0 001.323-.24l.044-.043a1.455 1.455 0 112.058 2.058l-.043.043a1.2 1.2 0 00-.24 1.324 1.2 1.2 0 001.098.727h.123a1.455 1.455 0 110 2.91h-.065a1.2 1.2 0 00-1.098.785 1.2 1.2 0 00.24 1.323l.044.044a1.455 1.455 0 11-2.059 2.058l-.043-.043a1.2 1.2 0 00-1.324-.24h-.058a1.2 1.2 0 00-.728 1.098v.123a1.455 1.455 0 11-2.909 0v-.065a1.2 1.2 0 00-.727-1.098 1.2 1.2 0 00-1.323.24l-.044.044a1.455 1.455 0 11-2.058-2.059l.043-.043a1.2 1.2 0 00.24-1.324v-.058a1.2 1.2 0 00-1.098-.728h-.123a1.454 1.454 0 110-2.909h.065a1.2 1.2 0 001.098-.727v0z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgSettings;